/**
 * Global AdminNav component. Up to the designers to decide if should live
 * as a top-nav, fixed side, menu-prompted, etc.
 *
 * Recommended to select a good one from Tailwind UI that matches the brand
 * and edit from there.
 * https://tailwindui.com/components/application-ui/headings/page-headings
 */
import React, {useEffect, useRef, useState} from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLoggedInUser } from '../../../resources/user/authService';
import { sendLogout } from '../../../resources/user/authStore';
import apiUtils from "../../utils/api";
import MenuIcon from "../MenuIcon";

const AdminNav = () => {
  // use the hook to get the loggedInUser from the authStore
  const loggedInUser = useLoggedInUser();

  const [openMenu, setOpenMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(false);
      }
    };

    if (openMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openMenu]);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const env_val = process.env.REACT_APP_ENV || 'production';
  // const withSentry = !['production'].includes(env_val);
    const withSentry = ![].includes(env_val);

  const triggerFrontendError = () => {
    const fullHost = window.location.origin;
    setTimeout(() => {
      throw new Error(`💥 Manual Frontend Error for Sentry. HOST: ${fullHost}`);
    }, 0);
  };


  const triggerBackendError = async () => {
    try {
      await apiUtils.callAPI('/api/users-test/test-sentry-backend', 'GET');
    } catch (e) {
      console.error("Caught backend error:", e);
    }
  };



    const handleLogout = async () => {
        await dispatch(sendLogout());
        dispatch({ type: 'LOGOUT' });
        localStorage.removeItem('user');
        history.replace("/user/login");
    }

  return (
    <header className="border-b border-solid shadow-sm bg-white">
      <div className="p-2 flex flex-col md:flex-row justify-center md:justify-between items-center">
        <button
            ref={menuRef}
            onClick={() => setOpenMenu(prev => !prev)}
            className={`ml-3 w-fit-content border-2 rounded-lg ${openMenu ? 'border-blue-500' : 'border-gray-400'} relative`}>
          <MenuIcon className={`w-[30px] h-[30px] ${openMenu ? 'text-blue-500' : 'text-gray-400'}`}/>
          <div className={`z-40 absolute py-2 w-fit-content bg-white rounded-xl border border-gray-400`} hidden={!openMenu}>
            <ul className="list-none p-0 flex flex-col">
              <li className="hover:bg-blue-100"><NavLink to="/admin" className="p-2 block hover:underline">Home</NavLink></li>
              <li className="hover:bg-blue-100"><NavLink to="/admin/users" className="p-2 block hover:underline">Users</NavLink></li>
              <li className="hover:bg-blue-100"><NavLink to="/admin/courses" className="p-2 block hover:underline">Courses</NavLink></li>
              <li className="hover:bg-blue-100"><NavLink to="/admin/questions/new" className="p-2 block text-nowrap hover:underline">Question Builder</NavLink></li>
              <li className="hover:bg-blue-100"><NavLink to="/admin/questions/bytag" className="p-2 block text-nowrap hover:underline">Question List by Tag</NavLink></li>
              <li className="hover:bg-blue-100"><NavLink to="/admin/referent-collections" className="p-2 block hover:underline">Referents</NavLink></li>
              <li className="hover:bg-blue-100"><NavLink to="/admin/constants" className="p-2 block hover:underline">Constants</NavLink></li>
              <li className="hover:bg-blue-100"><NavLink to="/admin/images?page=1&per=25&sort=name" className="p-2 block hover:underline">Images</NavLink></li>
              <li className="hover:bg-blue-100"><NavLink to="/admin/tags?page=1&per=25&sort=name&_tags=" className="p-2 block hover:underline">Tags</NavLink></li>
              <li className="hover:bg-blue-100"><NavLink to="/admin/assessments?page=1&per=25" className="p-2 block hover:underline">Assessments</NavLink></li>
              <li className="hover:bg-blue-100"><NavLink to='/admin/organisations?page=1&per=25' className="p-2 block hover:underline">Organisations</NavLink></li>
                <li className="hover:bg-blue-100"><NavLink to='/admin/subscriptions?page=1&per=25' className="p-2 block hover:underline">Subscriptions</NavLink></li>
              {withSentry && (
                  <>
                    <li className="hover:bg-blue-100">
                      <span onClick={triggerFrontendError} className="p-2 block text-red-600 text-nowrap cursor-pointer">
                        💥 Trigger Frontend Error
                      </span>
                    </li>
                    <li className="hover:bg-blue-100">
                      <span onClick={triggerBackendError} className="p-2 block text-orange-600 text-nowrap cursor-pointer">
                        💥 Trigger Backend Error
                      </span>
                    </li>
                  </>
              )}
            </ul>
          </div>
        </button>

        {!loggedInUser ?
            <ul className="list-none p-0 flex flex-col md:flex-row">
                <li>
                    <NavLink to={{ pathname: "/user/login", state: { from: location } }} className="p-2 block">
                        Sign in
                    </NavLink>
                </li>
                <li>
                    <NavLink to={{ pathname: "/user/register", state: { from: location } }} className="p-2 block">
                        Register
                    </NavLink>
                </li>
            </ul>
          :
          <ul className="list-none p-0 flex flex-col md:flex-row">
            <li>
                <p className="p-2 block">
                    {loggedInUser.username}
                </p>
            </li>
            <li>
                <NavLink to="/user/profile" className="p-2 flex justify-center md:justify-start">
                    My profile
                </NavLink>
            </li>
            <li className="flex justify-center md:justify-start">
                <button className="p-2 flex justify-center md:justify-start" onClick={handleLogout}>
                    Logout
                </button>
            </li>
          </ul>
        }
      </div>
    </header>
  )
}

export default AdminNav;
